
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../base/Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleConsultationClick = () => {
    window.REACT_APP_NAVIGATE('/booking');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleContactClick = () => {
    if (location.pathname === '/') {
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
    setIsMenuOpen(false);
  };

  const handleAboutClick = () => {
    if (location.pathname === '/') {
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
    setIsMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <h1>
              <button
                onClick={handleLogoClick}
                className="cursor-pointer hover:opacity-80 transition-opacity"
              >
                <img 
                  src="https://static.readdy.ai/image/a10f8604063c6fe0566ec3f4e3cab275/447fc6e0f06967eb7064cec918e1794c.png"
                  alt="Renew Integrative Wellness"
                  className="h-12 w-auto"
                />
              </button>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => {
                navigate('/');
                setIsMenuOpen(false);
              }}
              className="text-black hover:text-[#8A4F8A] transition-colors cursor-pointer"
            >
              Home
            </button>

            <div className="relative">
              <button
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                className="flex items-center text-black hover:text-[#8A4F8A] transition-colors cursor-pointer"
              >
                Services
                <i
                  className={`ri-arrow-down-s-line ml-1 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}
                ></i>
              </button>

              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  <button
                    onClick={() => {
                      navigate('/services/weight-loss');
                      setIsServicesOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                  >
                    Weight Loss
                  </button>
                  <button
                    onClick={() => {
                      navigate('/services/iv-therapy');
                      setIsServicesOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                  >
                    IV Therapy
                  </button>
                  <button
                    onClick={() => {
                      navigate('/services/peptide-therapy');
                      setIsServicesOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                  >
                    Peptide Therapy
                  </button>
                  <button
                    onClick={() => {
                      navigate('/services/sexual-wellness');
                      setIsServicesOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                  >
                    Sexual Wellness
                  </button>
                  <button
                    onClick={() => {
                      navigate('/services/mental-health');
                      setIsServicesOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                  >
                    Mental Health
                  </button>
                  <button
                    onClick={() => {
                      navigate('/services/hair-growth');
                      setIsServicesOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                  >
                    Hair Growth
                  </button>
                  <button
                    onClick={() => {
                      navigate('/services/longevity');
                      setIsServicesOpen(false);
                    }}
                    className="w-full text-left px-4 py-2 text-gray-700 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                  >
                    Longevity
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={() => {
                navigate('/blog');
                setIsMenuOpen(false);
              }}
              className="text-black hover:text-[#8A4F8A] transition-colors cursor-pointer"
            >
              Blog
            </button>

            <button
              onClick={handleAboutClick}
              className="text-black hover:text-[#8A4F8A] transition-colors cursor-pointer"
            >
              About
            </button>

            <button
              onClick={handleContactClick}
              className="text-black hover:text-[#8A4F8A] transition-colors cursor-pointer"
            >
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button onClick={handleConsultationClick}>
              Book Consultation
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-black`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
            <div className="px-4 py-2 space-y-2">
              <button
                onClick={() => {
                  navigate('/');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left py-2 text-gray-700 hover:text-[#8A4F8A] transition-colors cursor-pointer"
              >
                Home
              </button>

              <div className="space-y-1">
                <div className="py-2 text-gray-700 font-medium">Services</div>
                <button
                  onClick={() => {
                    navigate('/services/weight-loss');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-1 pl-4 text-gray-600 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                >
                  Weight Loss
                </button>
                <button
                  onClick={() => {
                    navigate('/services/iv-therapy');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-1 pl-4 text-gray-600 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                >
                  IV Therapy
                </button>
                <button
                  onClick={() => {
                    navigate('/services/peptide-therapy');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-1 pl-4 text-gray-600 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                >
                  Peptide Therapy
                </button>
                <button
                  onClick={() => {
                    navigate('/services/sexual-wellness');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-1 pl-4 text-gray-600 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                >
                  Sexual Wellness
                </button>
                <button
                  onClick={() => {
                    navigate('/services/mental-health');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-1 pl-4 text-gray-600 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                >
                  Mental Health
                </button>
                <button
                  onClick={() => {
                    navigate('/services/hair-growth');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-1 pl-4 text-gray-600 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                >
                  Hair Growth
                </button>
                <button
                  onClick={() => {
                    navigate('/services/longevity');
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left py-1 pl-4 text-gray-600 hover:text-[#8A4F8A] transition-colors cursor-pointer"
                >
                  Longevity
                </button>
              </div>

              <button
                onClick={() => {
                  navigate('/blog');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left py-2 text-gray-700 hover:text-[#8A4F8A] transition-colors cursor-pointer"
              >
                Blog
              </button>

              <button
                onClick={handleAboutClick}
                className="block px-3 py-2 text-black hover:text-[#8A4F8A] transition-colors cursor-pointer"
              >
                About
              </button>

              <button
                onClick={handleContactClick}
                className="block w-full text-left py-2 text-gray-700 hover:text-[#8A4F8A] transition-colors cursor-pointer"
              >
                Contact
              </button>

              <a href="tel:202-883-6057" className="text-[#8A4F8A] font-semibold">
                <i className="ri-phone-line mr-2"></i>
                (202) 883-6057
              </a>
              <Button size="sm" className="w-fit" onClick={handleConsultationClick}>
                Book Consultation
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
